import SecondaryScraper from './models/SecondaryScraper'
import { loadSecondaryScraper, saveSecondaryScraper } from '@/api/super'

export default {

  namespaced: true,

  state: {
    secondaryScraper: new SecondaryScraper()
  },

  mutations: {
    ...SecondaryScraper.mutations()
  },

  actions: {
    loadSecondaryScraper: ({ commit }, scraperId) => new Promise((resolve, reject) => {
      loadSecondaryScraper(scraperId, ({ data }) => {
        commit('setScraper', data)
        resolve()
      }, reject)
    }),
    save: ({state}) => new Promise((resolve, reject) => {
      saveSecondaryScraper(state.secondaryScraper, resolve, reject)
    })
  },
  
  getters: {
    secondaryScraper: state => state.secondaryScraper
  }

}